module.exports = __webpack_public_path__ + "static/media/clinical-mentorship-GOAL.8999c93d.jpg";